import { ck, interact, URLS } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import service from "../service/form";
export default {
  created() {
    window.$sk.loading.show();
    sbaseData.init();
    // document.title = "提交成功";
    window.$sk.template.module(this);
  },
  methods: {
    skUserEnd() {
      const info = window.$sk.template.get();
      this.tenantId = info.common.tenantId;
      this.user = info.user;
      if (sbaseData.isSetting) {
        this.initConfig();
        window.$sk.loading.hide();
        return;
      }
      this.customformGet();
    },
    customformGet() {
      service
        .getCustomform({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
          linkId: sbaseData.linkId,
          globalUserId: this.user.globalUserId,
        })
        .subscribe((data) => {
          if (data.result == 0) {
            this.formInfo = data.content;
            this.initConfig();
            this.initWeChatShare();
            this.interactiveBrowse();
            this.isShowAgain = this.formInfo.isReSubmit == 1;
            this.init();
          } else {
            window.$sk.tips.show(data.desc);
          }
        });
    },
    init() {
      const info = window.$sk.template.get();
      if (!sbaseData.preview || this.formInfo.attendWay == 3) {
        service
          .checkRegistration({
            customFormId: sbaseData.customFormId,
            tenantId: this.tenantId,
            instanceId:
              this.formInfo.attendWay == 4
                ? this.formInfo.meetingInstanceId
                : this.formInfo.instanceId,
            session: info.user.session,
            sess: info.user.session,
            openId: info.user.openId,
          })
          .subscribe((data) => {
            if (data.result == 0) {
              if (
                !this.isShowAgain &&
                data.content &&
                data.content.signupStatus === "allow"
              ) {
                window.location.hash = "#/";
                return;
              }
              window.$sk.loading.hide();
            } else {
              window.$sk.loading.hide();
            }
            document.title = "提交成功";
          });
      } else {
        window.$sk.loading.hide();
      }
    },
    // 需求成功页面需要添加浏览 来源 陈硕
    interactiveBrowse() {
      const info = window.$sk.template.get();
      service.browse({
        openId:
          this.user.openId ||
          ck.cookie("openId" + this.formInfo.attachWXAccount) ||
          "",
        sess: info.user.session || "",
        globalUserId: ck.cookie("globalUserId"),
        tenantId: this.formInfo.tenantId,
        customFormId: sbaseData.customFormId,
        markCode: sbaseData.markCode,
        marketingSess: ck.cookie("marketingSess"),
      });
    },
    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const formInfo = this.formInfo;
      let url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag",
        "excode",
        "loadcount",
        "scope"
      );
      url = url.split("#")[0] + "#/";
      const shareInfo = {
        title: formInfo.shareTitle || formInfo.title, // 分享标题,
        desc: formInfo.shareDesc || "", // 分享描述,
        link: sbaseData.weChatId
          ? window.config.weChatOauthUrl +
            "?weChatId=" +
            sbaseData.weChatId +
            "&scope=&return_url=" +
            encodeURIComponent(url)
          : url,
        imgUrl: formInfo.shareImageRealPath
          ? "https:" + formInfo.shareImageRealPath
          : "", // 分享图标
      };
      window.$swxsdk.initWxSdk(
        { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
        window.apiUrl
      );
      window.$swxsdk.on("sharer", shareInfo);
      window.$swxsdk.on("sharer_friends", shareInfo);
    },
  },
};
